var $ = require('jquery');
var _ = require('underscore');
var plupload = require('plupload');

var isInt = require('./functions/isInt');
var popupWizardWindow = require('./functions/popupWizardWindow');

var imageList = 0;
var previewList = 0;
var imageReloadIntervalHandle;
var currentlySelectedFile = 0;


/**
 * Action after image load.
 */
function previewOnLoad() {
    $("#preview-loader").hide();
    $("#item_photos").show();
    manageNextPrevArrows();
    checkPreviews();
}

function previewIsPending(url) {
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();
    return http.status == 202;
}

function checkPreviews() {
    var pendingPreviews = $('#item_photos .new_image:visible > img.pending-preview:visible');
    pendingPreviews.each(function(k, v) {
        var obj = $(v);
        if (obj.length > 0) {
            var src = obj.attr('src');
            var pos = src.indexOf('?');
            if (pos < 0) {
                pos = src.length;
            }
            src = src.substr(0, pos);
            src += '?_ts=' + new Date().getTime();

            if (previewIsPending(src)) {
                setTimeout(function() {
                    checkPreviews();
                }, 2000);
            }
            else {
                obj.attr('src', src);
                obj.removeClass('pending-preview');
            }
        }
    });
}

/**
 * Checks if images (list and preview) are loaded and sets or unsets
 * "Title".
 */
function checkIfImagesLoaded() {
    if (imageList && previewList) {
        if (uploader.files.length > 0) {
            if ($('#item_photos div').length == 1) {
                // sets basename of order
                var basename = uploader.files[uploader.files.length - 1]['name'].split(".");

                $('#newTitleInput').val(basename[0]);
                setTitle();
            }
        }

        clearInterval(imageReloadIntervalHandle);
    }
}

/**
 * Shows or hides arrows.
 */
function manageNextPrevArrows() {
    if ($('#item_photos > div').length <= 1) {
        $('.next').hide();
        $('.prev').hide();
    }
    else {
        $('.next').show();
        $('.prev').show();
    }
}

/**
 * Function adds widget.
 */
function addWizard(projectName) {
    $.ajax({
        url: RoutingS1.generate('addWizardSession'),
        type: 'POST',
        data: {
            productSlug: productSlug,
            projectName: projectName
        },
        success: function(content) {
            if (wizardSettingsTarget == 'popup') {
                reloadFileList();
            }
            else {
                window.location.href = lastOrderUrl;
            }
        }
    });
}

/**
 * Function change count input
 */
function changeCount(count) {
    $('#order_count').val(count);
}

/**
 * Reloads file list (normal files and wizards).
 */
function reloadFileList() {
    imageList = 0;
    previewList = 0;

    uploadLoader(true);
    previewLoader(true);
    $("#item_photos .new_image").remove();

    // hides arrows
    manageNextPrevArrows();

    // renders attachment list and preview list
    renderAttachmentList(renderPreviewList);
//         renderPreviewList();
}

/**
 * Checks if wizard project is attached to the current Order
 *
 * @return bool
 */
function hasWizardAttached() {
    return !($('li.wizard-li').length == 0);
}

/**
 * Renders attachment list and injects into list container.
 */
function renderAttachmentList(onSuccess) {
    $.ajax({
        url: RoutingS1.generate('requestAjaxHtml', {
            module: 'files',
            action: 'reqRenderAttachmentList'
        }),
        type: 'POST',
        data: {
            productSlug: productSlug,
            preview: preview ? '1' : '0',
            orderId: $('#order_order_id').val() ? $('#order_order_id').val() : 0
        },
        success: function(content) {
            if ($.trim(content)  != '') {
                $('#attachedFiles').html(content);

                $('#stop_upload').hide();

                uploadLoader(false);
            }

            // sets attachment list as loaded
            imageList = 1;

            // Consider displaying wizard button only when there are
            // source projects linked with product
            if (!_.isUndefined(hasSourceWizards) && hasSourceWizards) {
                // display wizard button only when there are no wizards attached ?>
                $('#addNewWizard').toggle(!hasWizardAttached());
            }

            if (!_.isUndefined(fileMultiPrintEnabled) && fileMultiPrintEnabled) {
                $(document).trigger('mnumi:order:recalculate.count');
            }
            onSuccess();
        }
    });
}

/**
 * Services default image.
 */
function serviceDefaultImage() {
    if ($('#item_photos div').length == 0) {
        $('#def_image').show();
        $('#item_photos div').hide();
    }
    else {
        $('#def_image').hide();
        $('#item_photos div:first-child').show();
    }
}

/**
 * Renders preview list and injects into preview container.
 */
function renderPreviewList() {
    // render preview list
    $.ajax({
        url: RoutingS1.generate('requestAjaxHtml', {
            module: 'files',
            action: 'reqRenderPreviewList'
        }),
        type: 'POST',
        data: {
            productSlug: productSlug,
            preview: preview ? '1' : '0',
            orderId: $('#order_order_id').val() ? $('#order_order_id').val() : 0
        },
        success: function(content) {
            if ($.trim(content)  != '') {
                $('#item_photos').html(content);
            }
            // hides preview loader
            previewLoader(false);

            serviceDefaultImage();

            // sets preview list as loaded
            previewList = 1;
            currentlySelectedFile = 0;

            if (croppingEnabled) {
                var imagePreview = $(".new_image:eq(" + currentlySelectedFile + ")").find('img:first:not(.pending-preview)');
                if (imagePreview.length) {
                    imagePreview.on('load', function() {
                        cropImage(currentlySelectedFile);
                    });
                }
            }
        }
    });
}

/**
 * Executes refresh action (after wizard edit).
 */
function editWizard() {
    reloadFileList();
}

/**
 * Wizard edit submit form action.
 */
function submitEditForm(parameter, signature) {
    $("#edit-parameter").val(parameter);
    $("#edit-signature").val(signature);

    // submits
    $("#wizard-edit-form").submit();
}

/**
 * Gets wizard pdf.
 *
 * @param parameter
 * @param signature
 * @param url
 */
function getWizardPdf(parameter, signature, url, button) {
    $(button).attr('disabled', 'disabled');
    url = url + '?parameter=' + parameter + '&signature=' + signature;

    if (wizardSettingsId) {
        url = url + '&id=' + wizardSettingsId;
    }

    location.href = url;

    setTimeout(function() {
        $(button).removeAttr('disabled');
    }, 5000);
}

/**
 * Switch loader or content.
 */
function uploadLoader(on) {
    if (on) {
        $("#uploader-interface").hide();
        $("#uploader-loader").show();
    }
    else {
        $("#uploader-interface").show();
        $("#uploader-loader").hide();
    }
}

/**
 * Switch loader or content.
 */
function previewLoader(on) {
    if (on) {
        $("#item_photos").hide();
        $('#def_image').hide();
        $("#preview-loader").show();
    }
    else {
        $("#item_photos").show();
        $("#preview-loader").hide();
    }
}

// sub navigation image
function changeSubImage(itemSubNo) {
    var image = $('.new_image:visible > img:visible');
    image.attr('src', '');

    var url = RoutingS1.generate('filePreview', {
        itemNo: image.attr('rel'),
        itemSubNo: itemSubNo
    }) + '?rand=' + Math.random();
    image.attr('src', url);

    previewLoader(true);
}

function isSingle() {
    return  $("#order_sides").val() == singleId
}

// WIZARD section
function gotoWizard() {
    let count = $("#order_count").val();

    if (isInt(count)) {
        // prepares wizard count parameter
        var wizardCount;
        if (isSingle()) {
            wizardCount = count;
        }
        else {
            wizardCount = count * 2;
        }

        $.ajax({
            type: 'POST',
            url: RoutingS1.generate('requestAjaxJson', {
                module: 'product',
                action: 'ReqWizardEncodedParamAndSignature'
            }),
            data: {
                count: wizardCount,
                countChange: wizardPageCountChange,
                productName: productName
            },
            dataType: 'json',
            error: function(xhr, ajaxOptions, thrownError) {
                alert(Translator.trans('There was error. Please try again later.'));
            },
            success: function(data) {
                if (data.status == 'success') {
                    $('#parameter').val(data.result.encodedParameter);
                    $('#signature').val(data.result.signature);

                    // // if popup then open popup
                    if (wizardSettingsTarget != 'self') {
                        popupWizardWindow();
                    }
                    $('#wizard-form').submit();
                }
            }
        });
    }
    else {
        alert(Translator.trans('"Page count" field must be valid integer.'));
    }
}

function getUploadUrl() {
    let orderId = $('#order_order_id').val();
    let uploaderUploadUrl = RoutingS1.generate('fileUploadToPanel', {
        order_id: orderId
    });
    if (!orderId || parseInt(orderId) < 1) {
        uploaderUploadUrl = RoutingS1.generate('fileUploadToPanel', {
            order_id: 0
        });
    }
    return uploaderUploadUrl;
}

window.previewOnLoad = previewOnLoad;
window.addWizard = addWizard;
window.changeCount = changeCount;
window.editWizard = editWizard;
window.submitEditForm = submitEditForm;

$(document).ready(function() {
    reloadFileList();

    /**
     * Services wizard add form.
     */
    $('#addNewWizard').click(function() {
        if ($('#orderNow').attr('disabled') == 'disabled') {
            alert(Translator.trans('Fill size in form: width and height'));
            return false;
        }
    });

    $('#open-gallery').click(function(e) {
        e.preventDefault();
        var width = $(window).width() * 0.9;
        var height = $(window).height() * 0.9;
        window.open($(this).data('href'), 'Gallery', "scrollbars=1,height=" + height + ",width=" + width);
    });

    // if uploader available
    if (!_.isUndefined(uploaderAvailable) && uploaderAvailable && (typeof plupload != "undefined")) {
        plupload.addI18n({
            'Select files' : Translator.trans('Select files'),
            'Add files to the upload queue and click the start button.' : Translator.trans('Add files to the upload queue and click the start button.'),
            'Filename' : Translator.trans('Filename'),
            'Status' : Translator.trans('Status'),
            'Size' : Translator.trans('Size'),
            'Add files' : Translator.trans('Add files'),
            'Add files.' : Translator.trans('Add files.'),
            'Stop current upload' : Translator.trans('Stop current upload'),
            'Start uploading queue' : Translator.trans('Start uploading queue'),
            'Start upload' : Translator.trans('Start upload'),
            'Drag files here.' : Translator.trans('Drag files here.'),
            'N/A' : Translator.trans('N/A'),
            'Uploaded' : Translator.trans('Uploaded'),
            'files' : Translator.trans('files'),
            'Uploaded %d/%d files': Translator.trans('Uploaded %d/%d files')
        });

        var pluploadOptions = {
            runtimes : 'html5,silverlight,flash,html4',
            browse_button : 'pickfiles',
            drop_element : 'mns',
            container : 'pluploader-container',
            chunk_size: "1mb",
            multipart: true,
            url : (function() {
                return getUploadUrl();
            })(),
            unique_names : true,
            flash_swf_url : '/js/plupload/plupload.flash.swf?1',
            silverlight_xap_url : '/js/plupload/plupload.silverlight.xap?1'
        }

        var uploader = new plupload.Uploader(pluploadOptions);

        uploader.bind('Init', function(up, params) {
            $('#filelist').html("<div></div>");

            if (up.features.dragdrop) {
                var target = null;
                var targetId = up.settings.drop_element;
                if ($.isArray(up.settings.drop_element) &&
                    up.settings.drop_element.length > 0
                ) {
                    targetId = up.settings.drop_element;
                }
                if (_.isString(targetId)) {
                    target = $("#" + targetId);
                }
                else if (_.isArray(targetId)) {
                    target = $(targetId[0]);
                }
                else {
                    target = targetId;
                }

                if (params && (params.runtime === 'html5')) {
                    target.bind('dragenter', function(event) {
                        $(this).trigger('mnumi:uploader:dragenter', event);
                    });

                    target.bind('dragleave', function(event) {
                        $(this).trigger('mnumi:uploader:dragleave', event);
                    });

                    target.bind('dragover', function(event) {
                        $(this).trigger('mnumi:uploader:dragover', event);
                    });

                    target.bind('drop', function(event) {
                        $(this).trigger('mnumi:uploader:drop', event);
                    });
                }
            }
        });

        uploader.bind('BeforeUpload', function(up, params) {
            up.settings.url = getUploadUrl() + '?name=' + params.name;
        });
        uploader.bind('ChunkUploaded', function(up, params, result) {
            var headers = result.responseHeaders.split("\n");
            for (var index in headers) {
                var header = headers[index].split(':');
                if (header.indexOf('x-order-id') == 0) {
                    var orderId = Number.parseInt(header[1]);
                    $('#order_order_id').val(orderId);

                    window.history.pushState(
                        {orderId: orderId},
                        'Order ' + orderId + ' created',
                        RoutingS1.generate('productEdit', {
                            order_id: orderId
                        })
                    );
                }
            }
        });

        uploader.init();

        uploader.bind('FilesAdded', function(up, files) {
            $('#addNewWizard').hide();
            $('#stop_upload').show();
            $.each(files, function(i, file) {
                $('#attachedFiles').append('<li id="' + file.id + '">' + file.name + ' <b></b>' + '</li>');
            });

            uploader.start();
            up.refresh(); // Reposition Flash/Silverlight
        });

        $('#stop_upload').click(function() {
            uploader.stop();
            reloadFileList();
            return false;
        });

        uploader.bind('UploadProgress', function(up, file) {
            $('#' + file.id + " b").html(file.percent + "%");
        });

        uploader.bind('Error', function(up, err) {
            $('#filelist').append("<li>Error: " + err.code +
                ", Message: " + err.message +
                (err.file ? ", File: " + err.file.name : "") +
                "</li>"
            );

            up.refresh(); // Reposition Flash/Silverlight
        });

        uploader.bind('FileUploaded', function(up, file, result) {
            $('#' + file.id + " b").html("100%");
            var headers = result.responseHeaders.split("\n");
            for (var index in headers) {
                var header = headers[index].split(':');
                if (header.indexOf('x-order-id') == 0) {
                    var orderId = Number.parseInt(header[1]);
                    $('#order_order_id').val(orderId);

                    window.history.pushState(
                        {orderId: orderId},
                        'Order ' + orderId + ' created',
                        RoutingS1.generate('productEdit', {
                            order_id: orderId
                        })
                    );
                }
            }
        });

        uploader.bind('StateChanged', function(uploader) {
            if (uploader.files.length === (uploader.total.uploaded + uploader.total.failed)) {
                reloadFileList();
                if (titleChangeable) {
                    imageReloadIntervalHandle = setInterval(checkIfImagesLoaded, 100);
                }
            }
        });
    }

    // FILE LIST AND PREVIEW section
    // reloads list at the beginning
//         serviceDefaultImage();

    // sets delete action (for normal files)
    $('body').on('click', '#attachedFiles li a.del_item', function() {
        uploadLoader(true);

        var itemNo = $(this).attr('id').substring(5);
        var type = $(this).data('type');

        $.ajax({
            url: RoutingS1.generate('fileDel'),
            type: 'POST',
            data: {
                itemNo: itemNo,
                type: type
            },
            success: function() {
                reloadFileList();
            }
        });

        // if no photos show def image
        if ($('#item_photos div').length == 0) {
            $('.new_image').hide();
            $('#def_image').show();
        }
        return false;
    });

    // PREVIEW service section
    // preview list
    $('body').on('click', '.previewList', function() {
        var nr = $("#attachedFiles li.showPreview").index($(this).parent());
        currentlySelectedFile = nr;

        $(".new_image").hide();
        $(".new_image:eq(" + nr + ")").show();

        if (croppingEnabled) {
            cropImage(currentlySelectedFile);
        }
    });

    $('.next').click(function() {
        var visible_img = $('#item_photos > div:visible');
        if (visible_img.next().children().attr('src')) {
            currentlySelectedFile++;
            visible_img.hide();
            visible_img.next().show();

            if (croppingEnabled) {
                cropImage(currentlySelectedFile);
            }
        }
        return false;
    });

    $('.prev').click(function() {
        var visible_img = $('#item_photos > div:visible');
        if (visible_img.prev().children().attr('src')) {
            currentlySelectedFile--;
            visible_img.hide();
            visible_img.prev().show();

            if (croppingEnabled) {
                cropImage(currentlySelectedFile);
            }
        }
        return false;
    });

    $('body').on('click', '.prevSubImage', function() {
        var index = $('.subNavImageSelect').val();
        var nextIndex = parseInt(index) - 1;

        if ($('.subNavImageSelect option[value='+nextIndex+']').length > 0) {
            changeSubImage(nextIndex-1);
            $('.subNavImageSelect').val(nextIndex);
        }
        return false;
    });

    $('body').on('click', '.nextSubImage', function() {
        var index = $('.subNavImageSelect').val();
        var nextIndex = parseInt(index) + 1;

        if ($('.subNavImageSelect option[value='+nextIndex+']').length > 0) {
            changeSubImage(index);
            $('.subNavImageSelect').val(nextIndex);
        }
        return false;
    });

    // page select
    $('body').on('change', '.subNavImageSelect', function() {
        changeSubImage(parseInt($(this).val())-1);
        return false;
    });

    $('input#order_name').val($.trim($('#title').html()));

    $('#order_informations').parent().addClass('informations-field');

    $('body').on('click', '#attachedFiles li a.del_wiz', function() {
        uploadLoader(true);

        $.ajax({
            url: RoutingS1.generate('deleteWizardSession'),
            type: 'POST',
            data: {
                projectName: $(this).attr('id'),
                productSlug: productSlug
            },
            success: function(content) {
                reloadFileList();
            }
        });
    });

    $('#simple_form').submit(function() {
        $('#ms-product-alert-notice > div').hide();
        $("#progressAndWait").show();

        var pdfPages = 0;
        $('#ms-product-gallery #item_photos .new_image').each(function() {
            if($(this).data('format') == 'PDF') {
                pdfPages += $(this).data('pages');
            }
        });

        if (pageMinCount || pageMaxCount) {
            if ((pdfPages > 0) && (
                (pageMinCount && pdfPages < pageMinCount) ||
                (pageMaxCount && pdfPages > pageMaxCount)
            )) {

                $("#progressAndWait").hide();
                $('.pageCountNotice').show().effect("highlight", {}, 2000);
                $("#progressAndWait").hide();
                return false;
            }
        }

        if(pageCountType) {
            var type = pdfPages%2 == 0 ? 'even' : 'odd';

            if (pdfPages > 0 && type != pageCountType) {
                $("#progressAndWait").hide();
                $('.pageCountTypeNotice').show().effect("highlight", {}, 2000);
                $("#progressAndWait").hide();
                return false;
            }
        }

        if (fileRequired) {
            if (($("#mns #attachedFiles > li").length < 1) &&
                ($('input#targetAction').val() != "addNewWizard"))
            {
                $("#progressAndWait").hide();
                $('.filesRequired').show().effect("highlight", {}, 2000);
                $("#progressAndWait").hide();
                return false;
            }
        }

        var data = $(this).serialize();
        var action = $(this).attr('action');

        if ($('input#targetAction').val() == 'addNewWizard') {
            $('#addNewWizard')
                .attr('disabled', 'disabled')
                .unbind('click')
            ;
        }

        $.ajax({
            url: action,
            type: 'POST',
            data: data,
            success: function(response) {
                var response = JSON.parse(response);

                if(response.status === 'success') {
                    $('#order_order_id').val(response.orderId);
                    window.history.pushState(null, null, response.orderUri);
                }

                let redirectUrl = response.redirectUrl;

                if (wizardSettingsTarget == 'self') {
                    location.href = redirectUrl;
                    return;
                }

                if ($('input#targetAction').val() != "addNewWizard") {
                    location.href = redirectUrl;
                    return;
                }

                if ($('input#targetAction').val() == "addNewWizard") {
                    var a = document.createElement('a');
                    a.href = redirectUrl;
                    a.target = wizardSettingsTarget;
                    document.body.appendChild(a);
                    a.click();
                    return;
                }
            }
        });

        return false;
    });
});
